import React from 'react';

import Base64Image from '../../../lib/components/Base64Image';
import I18n from '../../../lib/i18n';
import { IUnpackedRelatedProduct } from '../../../models/MessagePreview/UnpackedRelatedProduct';
import NewsText from './NewsText';

interface IProps {
  relatedProduct: IUnpackedRelatedProduct;
}

const OunceRelatedProduct = (props: IProps) => {
  const { relatedProduct } = props;

  return (
    <div className="related-product">
      <div className='related-product-image-wrapper'>
        { 
          relatedProduct.label_platform == 'ounce' &&
            <div className="related-product-top-bar" >
              <div className="related-product-top-bar-icon"></div>
            </div>
        }
        <Base64Image className="related-product-image" image={relatedProduct.image} />
        {
          relatedProduct.content_type && 
            <span className={'related-product-content-type-label'}>
              {relatedProduct.content_type}
            </span>
        }
      </div>
      <div className="related-product-name">
        <NewsText text={relatedProduct.name} />
      </div>
      <div className="related-product-wish">
        <div className="related-product-wish-icon"></div>
        <div className="related-product-wish-text"><NewsText text={I18n.t('messages.preview.wish_list')}/></div>
      </div>
    </div>
  );
};

export default OunceRelatedProduct;
